export const isBrowserNotificationSupported = () => typeof window !== 'undefined' && 'Notification' in window;

export const requestNotificationPermission = async () => {
  if (!isBrowserNotificationSupported()) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;

  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const sendBrowserNotification = (title, options = {}) => {
  if (!isBrowserNotificationSupported() || Notification.permission !== 'granted') return null;
  try {
    return new Notification(title, options);
  } catch (error) {
    console.error('Notification error:', error);
    return null;
  }
};

export const playNotificationSound = (type = 'default') => {
  if (typeof window === 'undefined') return;

  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    const audioCtx = new AudioContext();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.type = 'triangle';
    oscillator.frequency.setValueAtTime(type === 'alert' ? 540 : 440, audioCtx.currentTime);
    gainNode.gain.setValueAtTime(0.12, audioCtx.currentTime);

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.18);

    setTimeout(() => {
      oscillator.disconnect();
      gainNode.disconnect();
      if (audioCtx.close) audioCtx.close();
    }, 250);
  } catch (error) {
    console.warn('Unable to play notification sound:', error);
  }
};

export const notifyShopOwnerNewOrder = (shopName, orderId) => {
  const title = 'New Order Received';
  const body = `Order #${orderId.slice(0, 8)} has been placed for ${shopName}.`;
  sendBrowserNotification(title, { body, icon: '/favicon.ico' });
  playNotificationSound('alert');
};

export const notifyDeliveryAgentAssigned = (orderId, shopName = 'shop') => {
  const title = 'Delivery Assigned';
  const body = `Order #${orderId.slice(0, 8)} from ${shopName} is assigned to you.`;
  sendBrowserNotification(title, { body, icon: '/favicon.ico' });
  playNotificationSound('alert');
};
